import ContrastBlack from '@assets/icons/black-white.svg'
import { Icon } from './Icon'

export const ContrastBlackIcon = Icon(ContrastBlack)
